export default (listElementRef: any) => {
    const result: number[] = [];

    if (listElementRef) {
        const children = listElementRef.children;

        for (let i = 0; i < children.length; i++) {
            const isInView = children[i].classList.contains("in_view");

            if (isInView) {
                result.push(i);
            }
        }
    }

    return result;
};